import React, { useEffect } from "react";
import MainLayout from "../../Layout/mainLayout";
import { Link } from "react-router-dom";
import "./addBuilder.css";
import { useState } from "react";
// import { useLoadScript, Autocomplete } from "@react-google-maps/api";
import { addNewBuilder } from "../../Redux/Actions/builderActions";
import { useDispatch, useSelector } from "react-redux";
import AddImage from "../../Global Functions/addImage";
import { getEnums } from "../../Redux/Actions/enumsActions";
import toast from "react-hot-toast";
import { ScrollTop } from "../../Utils/helpers";

const AddBuilder = () => {
  const [builderData, setBuilderData] = useState({
    brand_name: "",
    organization_name: "",
    primary_email: "",
    secondary_email: "",
    primary_country_code: "",
    primary_contact_number: "",
    secondary_country_code: "",
    secondary_contact_number: "",
    timezone: "",
    pwd: "",
    lat: "76.5",
    lng: "76.5",
    street_address: "",
    city: "",
    state: "",
    country: "",
    zipcode: "",
    rera_id: "",
    authorized_persons: {
      name: "",
      email: "",
      country_code: "",
      contact_number: "",
      company_id: "",
      identity_proof: "",
    },
    document_list: [{ type: "", number: "" }],
  });

  const dispatch = useDispatch();

  const handleAddChange = (event) => {
    const { name, value } = event.target;
    setBuilderData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleNumberChange = (event) => {
    const newNumber = event.target.value;
    setBuilderData((prev) => {
      const updatedDocumentList = prev.document_list
        ? [...prev.document_list]
        : [];
      if (updatedDocumentList.length === 0) {
        updatedDocumentList.push({ type: "", number: newNumber });
      } else {
        updatedDocumentList[0] = {
          ...updatedDocumentList[0],
          number: newNumber,
        };
      }
      return { ...prev, document_list: updatedDocumentList };
    });
  };

  const handleTypeChange = (event) => {
    const newName = event.target.value;
    setBuilderData((prev) => {
      const updatedDocumentList = prev.document_list
        ? [...prev.document_list]
        : [];
      if (updatedDocumentList.length === 0) {
        updatedDocumentList.push({ type: newName, number: "" });
      } else {
        updatedDocumentList[0] = { ...updatedDocumentList[0], type: newName };
      }
      return { ...prev, document_list: updatedDocumentList };
    });
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    Object.keys(builderData).forEach((key) => {
      if (!builderData[key]) {
        return toast.error("Input fields cannot be empty!!!");
      }
    });

    if (builderData.pwd.length < 8) {
      return toast.error("Password must be more than 8 characters");
    }

    dispatch(addNewBuilder(builderData));
  };

  const { countryList } = useSelector((state) => state.country);
  const { enumsData } = useSelector((state) => state.enumsData);

  useEffect(() => {
    dispatch(getEnums());
  }, [dispatch]);

  const handleAuthorizedPersons = async (event) => {
    const { name, value } = event.target;
    const uploadedFile = event.target.files?.[0];
    if (name === "identity_proof" && uploadedFile) {
      try {
        const responseUrl = await AddImage(uploadedFile);
        setBuilderData((prevData) => ({
          ...prevData,
          authorized_persons: {
            ...prevData.authorized_persons,
            identity_proof: responseUrl,
          },
        }));
      } catch (error) {
        console.error(error.response);
      }
    } else {
      setBuilderData((prevData) => {
        if (name in prevData.authorized_persons) {
          return {
            ...prevData,
            authorized_persons: {
              ...prevData.authorized_persons,
              [name]: value,
            },
          };
        } else {
          return { ...prevData, [name]: value };
        }
      });
    }
  };

  useEffect(() => {
    ScrollTop();
  }, []);

  return (
    <MainLayout>
      <div className="grid-span-5 bg-white border-24 padding-20 temp-col-2 gap-10">
        <div className="flex-container flex-justify-between span2 align-center">
          <h1>Add Builder</h1>
          <Link to="/builders">
            <button className="button-class">View Builder List</button>
          </Link>
        </div>
        <h3 className="margin-0 span2 border-1-grey padding-10 border-10">
          Enter Builder Details
        </h3>
        <div>
          <span>
            Brand Name<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="brand_name"
          />
        </div>
        <div>
          <span>
            Organization Name<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="organization_name"
          />
        </div>
        <div className="form_div_column_select">
          <select
            onChange={handleAddChange}
            className="padding-10"
            name="primary_country_code"
            id=""
          >
            {Array.isArray(countryList?.data) &&
              countryList.data.map((country) => (
                <option
                  value={country.country_phone_code}
                  key={country.country_phone_code}
                >
                  {country.country_phone_code}
                </option>
              ))}
          </select>
          <div>
            <span className="span-class-flex">
              Primary Phone<span style={{ color: "red" }}>*</span>
            </span>
            <input
              onChange={handleAddChange}
              type="text"
              className="input-class"
              name="primary_contact_number"
            />
          </div>
        </div>
        <div>
          <span>
            Primary Email<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="primary_email"
          />
        </div>
        <div className="form_div_column_select">
          <select
            onChange={handleAddChange}
            className="padding-10"
            name="secondary_country_code"
            id=""
          >
            {Array.isArray(countryList?.data) &&
              countryList.data.map((country) => (
                <option
                  value={country.country_phone_code}
                  key={country.country_phone_code}
                >
                  {country.country_phone_code}
                </option>
              ))}
          </select>
          <div>
            <span className="span-class-flex">
              Secondary Phone<span style={{ color: "red" }}>*</span>
            </span>
            <input
              onChange={handleAddChange}
              type="text"
              className="input-class"
              name="secondary_contact_number"
            />
          </div>
        </div>
        <div>
          <span>
            Secondary Email<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="secondary_email"
          />
        </div>
        <div>
          <span>
            Builder ID<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
          />
        </div>
        <div>
          <span>
            Password<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="password"
            className="input-class"
            name="pwd"
          />
        </div>
        <div>
          <span>
            Street Address<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="street_address"
          />
        </div>
        <div>
          <span>
            Country<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="country"
          />
        </div>
        <div>
          <span>
            Select Time Zone<span style={{ color: "red" }}>*</span>
          </span>
          <select
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="timezone"
          >
            {enumsData?.data?.time_zones &&
              Object.entries(enumsData?.data?.time_zones).map(([_, value]) => (
                <option>
                  {value.offset_UTC} {value.timezone}
                </option>
              ))}
          </select>
        </div>
        <div>
          <span>
            State<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="state"
          />
        </div>
        <div>
          <span>
            City<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="city"
          />
        </div>
        <div>
          <span>
            Zip Code<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="zipcode"
          />
        </div>
        <div className="form_div_textarea">
          <span>
            About Builder<span style={{ color: "red" }}>*</span>
          </span>
          <textarea
            rows={8}
            type="text"
            className="width-90 border-24 padding-10"
          />
        </div>
        <div>
          <span>
            RERA Id<span style={{ color: "red" }}>*</span>
          </span>
          <input
            onChange={handleAddChange}
            type="text"
            className="input-class"
            name="rera_id"
          />
        </div>
        <div className="temp-col-2 span2 gap-10">
          <div>
            <h3>Authorised Person Details</h3>
            <div className="border-1-grey padding-20 border-24">
              <div>
                <span>
                  Name<span style={{ color: "red" }}>*</span>
                </span>
                <input
                  type="text"
                  className="input-class"
                  name="name"
                  value={builderData?.authorized_persons?.name}
                  onChange={handleAuthorizedPersons}
                />
              </div>
              <div className="flex-container gap-10">
                <div style={{ width: "50%" }}>
                  <span>
                    Email ID<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    type="text"
                    value={builderData?.authorized_persons?.email}
                    className="input-class"
                    name="email"
                    onChange={handleAuthorizedPersons}
                  />
                </div>
                <div
                  style={{ width: "50%" }}
                  className="form_div_column_select"
                >
                  <select
                    style={{ width: "19%" }}
                    name="country_code"
                    value={builderData?.authorized_persons?.country_code}
                    onChange={handleAuthorizedPersons}
                    id=""
                  >
                    {Array.isArray(countryList?.data) &&
                      countryList.data.map((country) => (
                        <option
                          value={country.country_phone_code}
                          key={country.country_phone_code}
                        >
                          {country.country_phone_code}
                        </option>
                      ))}
                  </select>
                  <div>
                    <span>
                      Primary Phone<span style={{ color: "red" }}>*</span>
                    </span>
                    <input
                      onChange={handleAuthorizedPersons}
                      type="text"
                      value={builderData?.authorized_persons?.contact_number}
                      className="input-class"
                      name="contact_number"
                    />
                  </div>
                </div>
              </div>
              <div className="flex-container gap-10">
                <div style={{ width: "50%" }}>
                  <span>
                    Company ID<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    onChange={handleAuthorizedPersons}
                    type="text"
                    name="company_id"
                    value={builderData?.authorized_persons?.company_id}
                    className="input-class"
                  />
                </div>
                <div style={{ width: "50%" }}>
                  <span>
                    Identity Proof<span style={{ color: "red" }}>*</span>
                  </span>
                  <input
                    onChange={handleAuthorizedPersons}
                    type="file"
                    name="identity_proof"
                    // value={builderData?.authorized_persons?.identity_proof}
                    className="input-class"
                  />
                </div>
              </div>
            </div>
          </div>
          <div>
            <h3>Builders Details</h3>
            <div className="border-1-grey padding-20 border-24">
              <div>
                <div>
                  <div className="margin-h-10" style={{ position: "relative" }}>
                    <span>
                      Identity Proof(1)<span style={{ color: "red" }}>*</span>
                    </span>
                    <input
                      className="input-class"
                      onChange={handleTypeChange}
                      type="text"
                      value={builderData.document_list?.[0]?.type || ""}
                      name="type"
                    />
                  </div>
                  <span>Document Type</span>
                  <input
                    className="input-class"
                    type="text"
                    onChange={handleNumberChange}
                    value={builderData.document_list?.[0]?.number || ""}
                    name="number"
                  />
                </div>
              </div>
            </div>
          </div>
          <div className="flex-end span2">
            <Link to="/builders">
              <button className="button-class-white">Cancel</button>
            </Link>
            <button className="button-class" onClick={handleSubmit}>
              Submit
            </button>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default AddBuilder;
